import React from 'react'
import { Switch, Route } from 'react-router-dom'

import LoginPage from './pages/LoginPage'
import TemplatesPage from './pages/TemplatesPage'
import CabinetPage from './pages/CabinetPage'

import './App.scss'

function App() {
  return (
    <div className="container-fluid" style={{paddingLeft: '0'}}>
      <Switch>
        <Route exact path="/" component={LoginPage} />
        <Route exact path="/templates" component={TemplatesPage} />
        <Route exact path="/cabinet" component={CabinetPage} />
      </Switch>
    </div>
  );
}

export default App
